module.exports = __webpack_public_path__ + "media/images/team/matt_arnow-9a2e139ebbca484f5aa1c6321554c275.png";